<nb-actions size="small" class="leftnav" *ngIf="isSidebarVisible">
    <nb-action class="user-action">
      <nb-user [nbContextMenu]="userMenu"
               [name]="UserFullName | uppercase"
               [picture]="'../../../assets/progress1.jpg'"
               class="w-100">
      </nb-user>
      <div class="user-mail"  >{{ UserEmailId }}</div>
      <div class="leftnav-trigger"[nbContextMenu]="userMenu">
        <svg width="4" height="12" viewBox="0 0 4 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.0013 3.33341C1.2649 3.33341 0.667969 2.73646 0.667969 2.00008C0.667969 1.2637 1.2649 0.666748 2.0013 0.666748C2.7377 0.666748 3.33464 1.2637 3.33464 2.00008C3.33464 2.73646 2.7377 3.33341 2.0013 3.33341ZM2.0013 7.33341C1.2649 7.33341 0.667969 6.73648 0.667969 6.00008C0.667969 5.26368 1.2649 4.66675 2.0013 4.66675C2.7377 4.66675 3.33464 5.26368 3.33464 6.00008C3.33464 6.73648 2.7377 7.33341 2.0013 7.33341ZM0.667969 10.0001C0.667969 10.7365 1.2649 11.3334 2.0013 11.3334C2.7377 11.3334 3.33464 10.7365 3.33464 10.0001C3.33464 9.26368 2.7377 8.66675 2.0013 8.66675C1.2649 8.66675 0.667969 9.26368 0.667969 10.0001Z" fill="#F7F8F9"/>
        </svg>
      </div>
    </nb-action>


  </nb-actions> 